import React, { useState, useEffect } from 'react';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useWaitOverlayStore } from './useWaitOverlayStore';
import './_waitOverlay.scss';

const FADE_OUT_MS = 300;

interface WaitOverlayProps {
    logoSrc?: string;
}

export const WaitOverlay: React.FC<WaitOverlayProps> = ({ logoSrc }) => {
    const isWaiting = useWaitOverlayStore((state) => state.isWaiting);
    const label = useWaitOverlayStore((state) => state.label);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (isWaiting) {
            setMounted(true);
        } else if (mounted) {
            const timer = setTimeout(() => setMounted(false), FADE_OUT_MS);
            return () => clearTimeout(timer);
        }
    }, [isWaiting]);

    if (!mounted) return null;

    return (
        <div className={`wait-overlay ${isWaiting ? 'visible' : ''}`}>
            <div className='wait-overlay__content'>
                <LoadIndicator
                    visible
                    height={32}
                    width={32}
                />
                {logoSrc && (
                    <div className='wait-overlay__brand'>
                        <img
                            className='wait-overlay__logo'
                            src={logoSrc}
                            alt={label}
                        />
                        <p className='wait-overlay__text'>{label}</p>
                    </div>
                )}
                {!logoSrc && <p className='wait-overlay__text'>{label}</p>}
            </div>
        </div>
    );
};
